import React, { FC } from "react";
import { Stack } from "@mui/material";
import { Outlet } from "@tanstack/react-router";
import { NotificationContextProvider } from "shared-ts-ui-notification";

export const UnauthenticatedRootPage: FC = () => {
  return (
    <Stack
      className={"UnauthenticatedRootPage"}
      sx={{
        height: "100%",
        p: 2,
        "> *": {
          flexGrow: 1,
          minHeight: 0,
          minWidth: 0,
        },
      }}
    >
      <NotificationContextProvider>
        <Outlet />
      </NotificationContextProvider>
    </Stack>
  );
};
